var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M865 4470 c-175 -23 -335 -137 -414 -294 -62 -121 -62 -129 -59 -970 l3 -761 26 -67 c14 -37 41 -89 58 -117 74 -115 224 -216 355 -240 39 -7 299 -11 742 -11 l682 0 4 -457 c4 -404 6 -464 22 -513 60 -184 198 -321 381 -377 56 -17 112 -18 825 -18 842 0 816 -2 945 63 82 41 185 140 228 219 15 28 36 86 47 129 19 74 20 113 20 868 0 862 1 852 -57 958 -31 58 -123 147 -181 177 -100 51 -103 51 -894 51 l-738 0 0 463 c0 264 -5 490 -10 527 -30 191 -184 342 -376 370 -82 11 -1519 11 -1609 0z m286 -574 c107 -71 99 -233 -14 -297 -88 -49 -198 -14 -246 78 -15 30 -14 119 3 151 50 95 168 126 257 68z m1140 0 c107 -71 99 -233 -14 -297 -88 -49 -198 -14 -246 78 -15 30 -14 119 3 151 50 95 168 126 257 68z m-1174 -997 c119 -45 150 -203 57 -291 -88 -81 -223 -55 -280 54 -31 60 -9 162 45 206 48 39 122 52 178 31z m1140 0 c38 -14 83 -57 99 -96 49 -113 -38 -243 -161 -243 -94 0 -175 80 -175 174 0 121 124 208 237 165z m1455 -648 c63 -31 121 -88 155 -153 27 -52 28 -56 28 -223 0 -159 -2 -173 -23 -213 -36 -67 -98 -129 -161 -159 -54 -27 -61 -28 -216 -28 l-160 0 -63 34 c-70 38 -119 89 -154 160 -21 42 -23 59 -23 206 0 142 2 165 21 206 26 55 82 120 131 150 70 44 100 49 263 46 140 -2 160 -4 202 -26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.9ab5a1674b122d22470ec302f897583c.svg";
export { ForwardRef as ReactComponent };